module.exports = __webpack_public_path__ + "static/img/challenge_banner.c3a4557.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/challenge/challenge_banner.png
// module id = ULbL
// module chunks = 1